import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2, Sparkles } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Lien invalide"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/email/verify-email", { token });
        setStatus("ok"); setMsg(data.message);
      } catch (err) {
        setStatus("error"); setMsg(err.response?.data?.detail || "Échec");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-5 h-5 text-gold" />
          <span className="font-heading text-2xl">Xook<span className="gold-text font-bold">Pub</span></span>
        </Link>
        <div className="gold-border-gradient p-10 text-center">
          {status === "loading" && <><Loader2 className="w-12 h-12 mx-auto text-gold animate-spin" /><p className="mt-4 label-mono">Vérification en cours...</p></>}
          {status === "ok" && <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-gold" />
            <h1 className="mt-4 font-heading text-2xl">Email confirmé</h1>
            <p className="mt-2 text-white/65">{msg}</p>
            <Link to="/dashboard" data-testid="verify-ok-cta" className="gold-btn mt-6 inline-flex">Aller au studio</Link>
          </>}
          {status === "error" && <>
            <XCircle className="w-12 h-12 mx-auto text-red-400" />
            <h1 className="mt-4 font-heading text-2xl">Lien invalide</h1>
            <p className="mt-2 text-white/65">{msg}</p>
            <Link to="/login" className="ghost-btn mt-6 inline-flex">Se connecter</Link>
          </>}
        </div>
      </div>
    </div>
  );
}
